<template>
  <v-container class="maxwidth">
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-toolbar card class="white" prominent>
            <v-toolbar-title class="mt-3 body-4 primary--text"><h5>{{profile.hotel}}</h5></v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text class="pa-4">
            <v-layout row>
              <v-flex xs12>
                {{profile.name}}
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                {{profile.email}}
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <a :href="getHrefUrl()">{{profile.hotel_url}}</a>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                {{profile.hotel_city}}
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 align-baseline>
                <v-avatar tile size="32px" class="mr-2">
                  <img :src="countryFlag()">
                </v-avatar>
                <span>{{ countryName() }}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                {{ $t("api_key") }}: {{user.uid}}
              </v-flex>
            </v-layout>

            <h3 class="mt-5">{{ $t("password_change") }}</h3>
            <v-layout row>
              <v-flex xs12 md8 lg4>
                <v-text-field
                  :label="$t('password')"
                  v-model="password"
                  type="password"
                  :rules="[() => password.length >= 5 || $t('enter_at_least_5_characters')]"
                  required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md8 lg4>
                <v-text-field
                  :label="$t('password_confirm')"
                  v-model="confirmPassword"
                  type="password"
                  :rules="[comparePasswords]"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md8 lg4>
                <v-btn @click="changePassword" :disabled="loading || !validPassword" :loading="loading">
                  {{ $t("password_change") }}
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import * as utils from '../../utils'

  export default {
    components: {
    },

    data () {
      return {
        loading: true,
        profile: {},

        password: '',
        confirmPassword: ''
      }
    },

    created () {
      var self = this
      self.loading = true

      utils.HTTP.get('profile')
        .then(response => {
          self.profile = response.data
          self.loading = false
        })
    },

    computed: {
      ...mapGetters({
        user: 'user'
      }),

      comparePasswords () {
        return this.password !== this.confirmPassword ? this.$t('password_match') : ''
      },
      validPassword () {
        return this.password && this.password.length >= 5 && this.password === this.confirmPassword
      }
    },

    methods: {
      countryFlag () {
        if (!this.profile.hotel_country) {
          return ''
        }
        return utils.getCountryFlagUrl(this.profile.hotel_country)
      },

      countryName () {
        if (!this.profile.hotel_country) {
          return ''
        }
        return utils.getCountryName(this, this.profile.hotel_country)
      },

      getHrefUrl () {
        return utils.getHrefUrl(this.profile.hotel_url)
      },

      changePassword () {
        if (!this.password || this.password.length < 5) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: '<center>' + this.$t('enter_at_least_5_characters') + '</center>',
            duration: 2000
          })
          return
        }
        this.loading = true

        utils.HTTP.post('profile/change-password', { password: this.password })
          .then(response => {
            if (response.data.status > 0) {
              this.password = ''
              this.confirmPassword = ''
              this.$swal({
                position: 'bottom-right',
                type: 'success',
                title: this.$t('password_change_done'),
                showConfirmButton: false,
                timer: 3000
              })
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            console.log('ERROR Blacklist - profile: ' + error)
            this.$swal({
              position: 'bottom-right',
              type: 'error',
              title: this.$t('password_change_error'),
              showConfirmButton: false,
              timer: 3000
            })
          })
      }
    }
  }
</script>

<style scoped>
  .maxwidth {
    max-width: 400px;
  }

</style>



// WEBPACK FOOTER //
// src/components/User/Profile.vue